export { AuthorCarouselRenderer } from './AuthorCarouselRenderer'
export type { Author } from './AuthorCarouselRenderer'
